const HLS_JS_DEFAULTS = {
    // debug: false,
    enableWebVTT: false,
    enableCEA708Captions: true,
    // autoStartLoad: true,
};

export default HLS_JS_DEFAULTS;


// WEBPACK FOOTER //
// ./src/player/defaults/HlsJS.js